<template>
    <div class="px-4 sm:px-6 lg:px-8">
        <div class="mt-4 flow-root">
            <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div class="inline-block min-w-full align-middle">
                    <table class="min-w-full animate-pulse">
                        <thead>
                        <tr>
                            <th class="py-3.5 pr-3 pl-4">
                                <div class="skeleton rounded h-6 w-3/4"></div>
                            </th>
                            <th class="px-3 py-3.5">
                                <div class="skeleton rounded h-6 w-1/2"></div>
                            </th>
                            <th class="px-3 py-3.5">
                                <div class="skeleton rounded h-6 w-1/2"></div>
                            </th>
                            <th class="px-3 py-3.5">
                                <div class="skeleton rounded h-6 w-1/2"></div>
                            </th>
                            <th class="relative py-3.5 pr-4 pl-3">
                                <div class="skeleton rounded h-6 w-1/4 ml-auto"></div>
                            </th>
                        </tr>
                        </thead>
                        <tbody class="divide-y divide-gray-100 bg-white rounded-lg shadow-sm">
                        <!-- Skeleton-row #1 -->
                        <tr class="cursor-default">
                            <td class="py-5 pr-3 pl-4">
                                <div class="flex items-center space-x-3">
                                    <div class="skeleton rounded-full w-10 h-10"></div>
                                    <div class="skeleton rounded h-4 w-24"></div>
                                </div>
                            </td>
                            <td class="px-3 py-5">
                                <div class="skeleton rounded h-4 w-16"></div>
                            </td>
                            <td class="px-3 py-5">
                                <div class="skeleton rounded h-4 w-20"></div>
                            </td>
                            <td class="px-3 py-5">
                                <div class="skeleton rounded h-4 w-12"></div>
                            </td>
                            <td class="relative py-5 pr-4 pl-3 text-right">
                                <div class="skeleton rounded inline-block h-8 w-8"></div>
                            </td>
                        </tr>
                        <!-- Skeleton-row #2 -->
                        <tr class="cursor-default">
                            <td class="py-5 pr-3 pl-4">
                                <div class="flex items-center space-x-3">
                                    <div class="skeleton rounded-full w-10 h-10"></div>
                                    <div class="skeleton rounded h-4 w-24"></div>
                                </div>
                            </td>
                            <td class="px-3 py-5">
                                <div class="skeleton rounded h-4 w-16"></div>
                            </td>
                            <td class="px-3 py-5">
                                <div class="skeleton rounded h-4 w-20"></div>
                            </td>
                            <td class="px-3 py-5">
                                <div class="skeleton rounded h-4 w-12"></div>
                            </td>
                            <td class="relative py-5 pr-4 pl-3 text-right">
                                <div class="skeleton rounded inline-block h-8 w-8"></div>
                            </td>
                        </tr>
                        <!-- Skeleton-row #3 -->
                        <tr class="cursor-default">
                            <td class="py-5 pr-3 pl-4">
                                <div class="flex items-center space-x-3">
                                    <div class="skeleton rounded-full w-10 h-10"></div>
                                    <div class="skeleton rounded h-4 w-24"></div>
                                </div>
                            </td>
                            <td class="px-3 py-5">
                                <div class="skeleton rounded h-4 w-16"></div>
                            </td>
                            <td class="px-3 py-5">
                                <div class="skeleton rounded h-4 w-20"></div>
                            </td>
                            <td class="px-3 py-5">
                                <div class="skeleton rounded h-4 w-12"></div>
                            </td>
                            <td class="relative py-5 pr-4 pl-3 text-right">
                                <div class="skeleton rounded inline-block h-8 w-8"></div>
                            </td>
                        </tr>
                        <!-- Skeleton-row #4 -->
                        <tr class="cursor-default">
                            <td class="py-5 pr-3 pl-4">
                                <div class="flex items-center space-x-3">
                                    <div class="skeleton rounded-full w-10 h-10"></div>
                                    <div class="skeleton rounded h-4 w-24"></div>
                                </div>
                            </td>
                            <td class="px-3 py-5">
                                <div class="skeleton rounded h-4 w-16"></div>
                            </td>
                            <td class="px-3 py-5">
                                <div class="skeleton rounded h-4 w-20"></div>
                            </td>
                            <td class="px-3 py-5">
                                <div class="skeleton rounded h-4 w-12"></div>
                            </td>
                            <td class="relative py-5 pr-4 pl-3 text-right">
                                <div class="skeleton rounded inline-block h-8 w-8"></div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
</script>